var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.697 21.9768H8.28035C5.15535 21.9768 3.07202 20.4143 3.07202 16.7684V9.47676C3.07202 5.83093 5.15535 4.26843 8.28035 4.26843H18.697C21.822 4.26843 23.9053 5.83093 23.9053 9.47676V16.7684C23.9053 20.4143 21.822 21.9768 18.697 21.9768Z",
    fill: "#347D73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.489 14.0245C12.614 14.0245 11.7286 13.7537 11.0515 13.2016L7.79106 10.5974C7.45773 10.3266 7.39524 9.837 7.66607 9.50367C7.9369 9.17033 8.42649 9.10784 8.75982 9.37867L12.0202 11.9828C12.8119 12.6183 14.1556 12.6183 14.9473 11.9828L18.2077 9.37867C18.5411 9.10784 19.0411 9.15992 19.3015 9.50367C19.5723 9.837 19.5202 10.337 19.1765 10.5974L15.9161 13.2016C15.2494 13.7537 14.364 14.0245 13.489 14.0245Z",
    fill: "#347D73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon02);
export default __webpack_public_path__ + "static/media/note-icon-02.2e558d8b008310935a73252bcca69691.svg";
export { ForwardRef as ReactComponent };